import React from 'react';
import { Stack, Tooltip } from 'components';

interface IconProps {
  color?: string;
}
const ReeligibilityIcon: React.FC<IconProps> = ({ color = '#188AA1' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M4.27703 5.94562C3.97037 5.63896 3.4437 5.69229 3.23703 6.07229C3.05037 6.41229 2.9037 6.75896 2.79037 7.12562C2.6637 7.54562 2.99703 7.95895 3.43037 7.95895H3.43703C3.7237 7.95895 3.9837 7.77229 4.0637 7.49229C4.1437 7.22562 4.25037 6.96562 4.3837 6.71229C4.53037 6.46562 4.4837 6.15229 4.27703 5.94562ZM3.4437 9.29229H3.43037C2.99703 9.29229 2.6637 9.70562 2.79037 10.1256C2.89703 10.4856 3.0437 10.839 3.23037 11.179C3.43703 11.559 3.97037 11.619 4.27703 11.3123C4.47703 11.1056 4.53037 10.799 4.39037 10.5456C4.25703 10.299 4.15037 10.039 4.07037 9.77229C3.99037 9.47895 3.73037 9.29229 3.4437 9.29229ZM5.3437 13.3056C5.6837 13.4923 6.03703 13.639 6.4037 13.7456C6.81703 13.8656 7.23037 13.5323 7.23037 13.1056V13.0856C7.23037 12.799 7.0437 12.539 6.7637 12.459C6.49703 12.379 6.2437 12.2723 5.99703 12.139C5.7437 11.999 5.4237 12.0456 5.2237 12.2523L5.2037 12.2723C4.9037 12.5723 4.9637 13.099 5.3437 13.3056ZM8.57037 3.33896V2.89896C8.57037 2.30562 7.85037 2.00562 7.43037 2.42562L6.01703 3.84562C5.75037 4.11229 5.75037 4.53896 6.01703 4.79896L7.43703 6.18562C7.85703 6.59896 8.57037 6.29895 8.57037 5.70562V4.68562C10.4637 5.00562 11.9037 6.64562 11.9037 8.62562C11.9037 10.4456 10.6904 11.9723 9.0237 12.459C8.75037 12.539 8.57037 12.799 8.57037 13.0856V13.099C8.57037 13.5323 8.97703 13.859 9.39037 13.739C11.617 13.099 13.237 11.0523 13.237 8.62562C13.237 5.90562 11.2037 3.66562 8.57037 3.33896Z"
        fill={color}
      />
    </svg>
  );
};

interface Props {
  text: string;
  color?: string;
  padding?: string;
}

const ReeligibilityInfo: React.FC<Props> = ({ text, color, padding }) => {
  return (
    <Stack padding={padding} sx={{ cursor: 'default' }}>
      <Tooltip toolTipText={text} placement="bottom" blackTooltip>
        <ReeligibilityIcon color={color} />
      </Tooltip>
    </Stack>
  );
};

export default ReeligibilityInfo;
